<script setup lang="ts">
import type { CustomerIntent } from 'shared/src'
import { useValidations } from '@/composables/api/useValidations'

const { t } = useI18n()

const modelValue = defineModel<CustomerIntent[]>({
  required: true,
  default: () => [],
})
const { visibleErrors } = useValidations()
</script>

<template>
  <IntentsTable
    v-model="modelValue"
    :label="t('intent_recognition')"
    :subtitle="t('intents.subtitle')"
    required
    :error="visibleErrors.customer_intents?._"
  />
</template>
